module.exports = __webpack_public_path__ + "img/946bebf.svg";